<template>
  <v-row class="login fill-height align-center no-gutters">
    <v-col class="d-flex flex-column justify-center col-6 fill-height">
      <image-mobile-app></image-mobile-app>
    </v-col>
    <v-col class="d-flex flex-column justify-center col-6 right-col">
      <h4 class="mb-5 text-uppercase">Identifiez-vous</h4>
      <p class="mb-16">Bienvenue sur l’interface de gestion de Smart Resident ! Connectez-vous et prenez soin de vos locataires.</p>
      <login-form @complete="$router.push('/')"></login-form>
    </v-col>
  </v-row>
</template>

<script>
import loginForm from '@/components/LoginForm.vue'
import imageMobileApp from '@/components/ImageMobileApp.vue'

export default {
    name: 'Login',
    components: { loginForm, imageMobileApp }
}
</script>

<style lang="scss">
  .login{
    .right-col{
      padding: 20vh 10vw !important;
    }
  }
</style>